import { ID } from '../../utils/codecUtils';
import { organizationSchema } from '../models/organization.schema';

export const get = (organizationId: ID) => {
  return {
    endpoint: `/organizations/${organizationId}`,
    method: 'GET',
    responseSchema: organizationSchema,
  } as const;
};
